<div class="app-container flex-col">
    <app-license-banner></app-license-banner>
    <div class="app-header">
        <app-default-navbar></app-default-navbar>
    </div>

    <div class="app-body flex-row">
        <div class="app-sidebar">
            <app-default-sidebar></app-default-sidebar>
        </div>

        <div class="flex-col content">
            <div class="app-content-header">
                <app-default-header-layout
                    [title]="config?.title"
                    [subtitle]="config?.subtitle"
                    [date]="config?.date"
                    [imageKey]="config?.imageKey"
                    [imageType]="config?.imageType"
                ></app-default-header-layout>
            </div>

            <div class="app-content">
                <router-outlet></router-outlet>

                <div class="app-footer">
                    <app-default-footer></app-default-footer>
                </div>
            </div>
        </div>
    </div>
</div>
